/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `ok` - ok
 * * `already_in_progress` - already_in_progress
 * @export
 */
export const PdfExportResponseStatusEnum = {
    Ok: 'ok',
    AlreadyInProgress: 'already_in_progress'
} as const;
export type PdfExportResponseStatusEnum = typeof PdfExportResponseStatusEnum[keyof typeof PdfExportResponseStatusEnum];


export function instanceOfPdfExportResponseStatusEnum(value: any): boolean {
    for (const key in PdfExportResponseStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(PdfExportResponseStatusEnum, key)) {
            if (PdfExportResponseStatusEnum[key as keyof typeof PdfExportResponseStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PdfExportResponseStatusEnumFromJSON(json: any): PdfExportResponseStatusEnum {
    return PdfExportResponseStatusEnumFromJSONTyped(json, false);
}

export function PdfExportResponseStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfExportResponseStatusEnum {
    return json as PdfExportResponseStatusEnum;
}

export function PdfExportResponseStatusEnumToJSON(value?: PdfExportResponseStatusEnum | null): any {
    return value as any;
}

export function PdfExportResponseStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): PdfExportResponseStatusEnum {
    return value as PdfExportResponseStatusEnum;
}

